













































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { PostsApi, PostPostRequest } from "../../../apis";
import * as moment from "moment";

@Component({
  components: {},
})
export default class AddInstructionReview extends Vue {
  subjectEn = "";
  headerUrlEn = "";
  headerUrlVn = "";
  shortDescriptionEn = "";
  contentEn = "";
  subjectVn = "";
  shortDescriptionVn = "";
  contentVn = "";
  createdAt = "";
  isEn = true;
  isVn = false;
  headerImageHeight = "100%";
  updatedAt = moment(new Date()).format("D MMM, YYYY HH:mmA");

  getEdit() {
    this.$router.push({ name: "add-instruction" });
  }

  mounted() {
    this.getReviewDetail();
  }

  get userStore() {
    return this.$store.state.user;
  }

  get instructionStore() {
    return this.userStore.instruction;
  }

  resetData() {
    this.userStore.instruction = null;
  }

  getReviewDetail() {
    if (this.$store.getters.locale === "vi") {
      this.isEn = false;
      this.isVn = true;
    } else {
      this.isVn = false;
      this.isEn = true;
    }
    this.subjectEn = this.instructionStore.instructionSubjectEn;
    this.headerUrlEn = this.instructionStore.instructionHeaderUrlEn;
    this.headerUrlVn = this.instructionStore.instructionHeaderUrlVn;
    this.shortDescriptionEn =
      this.instructionStore.instructionShortDescriptionEn;
    this.contentEn = this.instructionStore.instructionContentEn;
    this.subjectVn = this.instructionStore.instructionSubjectVn;
    this.shortDescriptionVn =
      this.instructionStore.instructionShortDescriptionVn;
    this.contentVn = this.instructionStore.instructionContentVn;
  }

  get currentLocale() {
    return this.$store.getters.locale;
  }

  onLoadImageCompleted(event) {
    const headerImageEle = document.getElementById(
      "header-img"
    ) as HTMLImageElement;
    if (headerImageEle) {
      this.headerImageHeight = "" + headerImageEle.height;
      headerImageEle.classList.add("tw-hidden");
    }
  }

  @Watch("currentLocale")
  onCurrentLocaleWatch() {
    this.getReviewDetail();
  }

  postPostRequest: PostPostRequest = {} as any;
  async publicInstruction() {
    this.postPostRequest = {
      subjectEn: this.subjectEn,
      headerUrlEn: this.headerUrlEn,
      shortDescriptionEn: this.shortDescriptionEn,
      contentEn: this.contentEn,
      subjectVn: this.subjectVn,
      headerUrlVn: this.headerUrlVn,
      shortDescriptionVn: this.shortDescriptionVn,
      contentVn: this.contentVn,
      isAbout: false,
    } as PostPostRequest;
    try {
      const rs = await new PostsApi().createPost({
        postPostRequest: this.postPostRequest,
      });
    } catch {
    } finally {
      this.resetData();
      this.$router.push({ name: "instructions" });
    }
  }
}
